export default {
  "pet-list.jpg": require("@/assets/images/richHtml/lovableHome/screens/pet-list.jpg"),
  "help-guide.jpg": require("@/assets/images/richHtml/lovableHome/screens/help-guide.jpg"),
  "harness-detail-page2.jpg": require("@/assets/images/richHtml/lovableHome/screens/harness-detail-page2.jpg"),
  "upload-nose-print.jpg": require("@/assets/images/richHtml/lovableHome/screens/upload-nose-print.jpg"),
  "profile-logged-in.jpg": require("@/assets/images/richHtml/lovableHome/screens/profile-logged-in.jpg"),
  "device-list.jpg": require("@/assets/images/richHtml/lovableHome/screens/device-list.jpg"),
  "scan-harness.jpg": require("@/assets/images/richHtml/lovableHome/screens/scan-harness.jpg"),
  "login-select.jpg": require("@/assets/images/richHtml/lovableHome/screens/login-select.jpg"),
  "reminder.jpg": require("@/assets/images/richHtml/lovableHome/screens/reminder.jpg"),
  "add-pet-step2.jpg": require("@/assets/images/richHtml/lovableHome/screens/add-pet-step2.jpg"),
};
